/* eslint-disable linebreak-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import { DiscussForm } from "parts/DiscussForm";

import Header from "parts/Header";
import Footer from "parts/Footer";

export const DiscussProjectPage = () => {
  const [formData, setFormData] = useState({
    expectations: "",
    motivation: "",
    dreamGoals: "",
    challenges: [],
    preferredSupport: "",
    name: "",
    age: "",
    location: "",
    treatmentDuration: "",
    treatmentCompleted: "",
    email: "",
  });

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onChange = (id, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      expectations: "",
      motivation: "",
      dreamGoals: "",
      challenges: [],
      preferredSupport: "",
      name: "",
      age: "",
      location: "",
      treatmentDuration: "",
      treatmentCompleted: "",
      email: "",
    });
  };

  return (
    <>
      <Header />
      {/* Center the DiscussForm */}
      <div className="flex items-center justify-center min-h-screen bg-gray-100 overflow-x-hidden">
        <div className="w-full max-w-3xl mx-auto px-4 sm:px-8 md:px-16 lg:px-20">
          <DiscussForm
            formData={formData}
            onChange={onChange}
            resetForm={resetForm}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};
